export * from './types';
export { default as SvgFill } from './primitives/fill';
export { default as SvgStroke } from './primitives/stroke';
export { default as SvgText } from './primitives/text';
export { default as SvgBase } from './primitives/svg';
export { default as SvgIcon } from './variants/SvgIcon';
export { default as FeatureIllustrationSvgIcon } from './variants/FeatureIllustrationSvgIcon';
export { default as SceneIllustrationSvgIcon } from './variants/SceneIllustrationSvgIcon';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/svg-icon/dist/esm/index.js
// module id = 1
// module chunks = 11